import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
var ONE_DAY = 1000 * 60 * 60 * 24;
/**
 * Adds one leading zero if the number less than 10
 * @param {number} number
 */

export function addLeadingZero(number) {
  return number < 10 ? "0".concat(number) : String(number);
}
/**
 * Forms the from date for the date picker
 * @param {string} date
 * @returns {string} formatted date of the start of the month
 */

export function formStartOfMonthDateString(date) {
  var tempDate = new Date(date);
  var month = tempDate.getMonth() + 1;
  month = addLeadingZero(month);
  var year = tempDate.getFullYear();
  return "".concat(year, "-").concat(month, "-01");
}
/**
 * Formats date to YYYY-MM-DD
 * @param {Date} date
 */

export function formatDate(date) {
  var month = date.getMonth() + 1;
  month = addLeadingZero(month);
  var year = date.getFullYear();
  var day = addLeadingZero(date.getDate());
  return "".concat(year, "-").concat(month, "-").concat(day);
}
/**
 * Returns date of start of next month
 * @param {string} dateString - any date string
 * @returns {Date} date of start of next month
 */

export function getNextMonth(dateString) {
  var tempDate = new Date(dateString);
  var year = tempDate.getFullYear();
  var month = tempDate.getMonth() + 2;

  if (month > 12) {
    year++;
    month = 1;
  }

  month = addLeadingZero(month);
  return new Date("".concat(year, "-").concat(month, "-01"));
}
/**
 * Returns true if the end date is earlier than start date
 * @param {string} startDateString - start date string
 * @param {string} endDateString - end date string
 * @returns {boolean}
 */

export function isDateEarlier(startDateString, endDateString) {
  var startDate = new Date(startDateString);
  var endDate = new Date(endDateString);
  return +endDate - startDate < 0;
}
/**
 * Returns the date string in format YYYY-MM-DD from the input number of days
 * from the end of the month
 * @param {string} dateString - any date string
 * @param {number} days - number of days from the end of month
 * @returns {string}
 */

export function getDateFromTheEndOfMonth(dateString, days) {
  var date = new Date(getNextMonth(dateString) - ONE_DAY * (days + 1));
  return formatDate(date);
}
/**
 * Returns start of last four weeks of month in format YYYY-MM-DD
 * @param {string} dateString - any date string
 * @returns {string} formatted date of the start of the month
 */

export function formStartOfForthWeeksOfMonthDateString(dateString) {
  return getDateFromTheEndOfMonth(dateString, 27);
}
/**
 * Returns last day of month in format YYYY-MM-DD
 * @param {string} dateString - any date string
 * @returns {string} formatted date of the end of the month
 */

export function formEndOfMonthDateString(dateString) {
  return getDateFromTheEndOfMonth(dateString, 0);
}
/**
 * Returns date in format YYYY-MM-DD before the input days
 * @param {string} dateString - any date string
 * @param {number} days - number of days before the input date
 * @returns {string}
 */

export function getDateStringBeforeDays(dateString, days) {
  var inputDate = new Date(dateString);
  var outputDate = new Date(+inputDate - days * ONE_DAY);
  return formatDate(outputDate);
}
/**
 * Returns date in format YYYY-MM-DD after the input days
 * @param {string} dateString - any date string or 'now'
 * @param {number} days - number of days after the input date
 * @returns {string}
 */

export function getDateStringAfterDays(dateString, days) {
  var inputDate = dateString === 'now' ? new Date() : new Date(dateString);
  var outputDate = new Date(+inputDate + days * ONE_DAY);
  return formatDate(outputDate);
}
/**
 * Returns date in format YYYY-MM-DD after the input days
 * @param {string} dateStringStart - any date string
 * @param {string} dateStringEnd - any date string
 * @returns {string}
 */

export function getDeltaDays(dateStringStart, dateStringEnd) {
  var startDate = new Date(dateStringStart);
  var endDate = new Date(dateStringEnd);
  var delta = +startDate - +endDate;
  return Math.floor(delta / ONE_DAY);
}
/**
 * Returns current date in format YYYY-MM-DD
 */

export function getCurrentDayString() {
  var today = new Date();
  return formatDate(today);
}
export function isValidDateString(dateString) {
  return !Number.isNaN(Date.parse(dateString));
}
export function getStartEndTime(startDate, endDate) {
  var startTime = isValidDateString(startDate) ? new Date(startDate).toLocaleString('ru', {
    hour: '2-digit'
  }) : '???';
  var endTime = isValidDateString(endDate) ? new Date(endDate).toLocaleString('ru', {
    hour: '2-digit'
  }) : '???';
  return startTime + '-' + endTime;
}
export function getShortTime(dateTime) {
  var _dateTime$split, _dateTime$split$;

  var time = dateTime === null || dateTime === void 0 ? void 0 : (_dateTime$split = dateTime.split('T')) === null || _dateTime$split === void 0 ? void 0 : (_dateTime$split$ = _dateTime$split[1]) === null || _dateTime$split$ === void 0 ? void 0 : _dateTime$split$.split(':');

  if (time) {
    return time[0] + ':' + time[1];
  } else {
    return '???';
  }
}
/**
 * Converts the number of hours in numerical form to the format hh:mm:00
 * @param {number} val - number of hours
 * @param {boolean} secondsNeeded - if true returns hh:mm:00 else only hh:mm
 */

export function numberToTimeString(val) {
  var secondsNeeded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var divider = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ':';

  if (typeof val !== 'number') {
    return null;
  }

  var minutes = Math.round(val * 60);
  var hours = (minutes - minutes % 60) / 60;
  minutes = minutes % 60;
  var output = "".concat(addLeadingZero(hours)).concat(divider).concat(addLeadingZero(minutes));
  return secondsNeeded ? output + "".concat(divider, "00") : output;
}

function decimalAdjust(value, exp) {
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math.round(value);
  }

  value = +value;
  exp = +exp;

  if (Number.isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return Number.NaN;
  }

  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
}
/**
 * Converts the number of hours in from format hh:mm:00 into numerical form
 * @param {string} timeString - number of hours in format hh:mm:00
 */


export function timeStringToNumber(timeString) {
  var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';

  if (typeof timeString === 'number') {
    return timeString;
  }

  if (typeof timeString !== 'string') {
    return '';
  }

  var parsed = timeString.split(divider);
  return +parsed[0] + decimalAdjust(+parsed[1] / 60, -2);
}
export function convertNumberToHHMM(number) {
  var hourLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ч';
  var minuteLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'м';
  var value = number;

  if (typeof number === 'string') {
    value = timeStringToNumber(number);
  }

  var hours = Math.floor(value);
  var minutes = ((value - hours) * 60).toFixed(0);
  return "".concat(hours).concat(hourLabel, " ").concat(minutes).concat(minuteLabel);
}
/**
 *  returns date in format 2021-12-16T08:00:00
 * @param {Date} date
 */

export function dateToDateString(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var time = date.toLocaleTimeString('ru');
  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(time);
}
export function formTimeStringValue(val) {
  var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (typeof val === 'string') {
    return val;
  }

  return val ? numberToTimeString(val, false, '.') : defaultVal;
}
export function datesInOneMonth(from, to) {
  return parseYearMonth(from) === parseYearMonth(to);
}
export function parseYearMonth(date) {
  return date.split('-').slice(0, 2).join('');
}